import { useEffect, useState } from 'react';
import { Select } from '@tencent/spaui';
import _ from 'lodash';
import { getPotentialReason } from './api';

interface PotentialReasonSelectProps {
  potentialStatus: string | string[]; // 商机状态
  value: string; // 商机原因
  onChange: (e: any, value: string) => void;
  onClear?: (e: any, value: string) => void;
  reportHubKey?: string;
}

const reportHubDefaultKey = 'potential-reason-select';

const handleReasonList = (data: object, potentialStatus: string | string[]) => {
  const handle = (_data: object) => {
    return _.reduce(_.values(_data), (result, value) => {
      return Object.assign({}, result, value);
    }, {});
  };
  if (!potentialStatus) {
    return handle(data);
  }
  const reasonList = {};
  if (_.isArray(potentialStatus)) {
    _.map(data, (obj, value: string) => {
      if (_.includes(potentialStatus, value)) {
        return reasonList[value] = obj;
      }
    });
    return handle(reasonList);
  }
  if (_.isString(potentialStatus)) {
    return data[potentialStatus];
  }
};

const PotentialReasonSelect = (props: PotentialReasonSelectProps) => {
  const [data, setData] = useState({});
  const { potentialStatus, value, onChange, onClear, reportHubKey } = props;
  const reportKey = reportHubKey || reportHubDefaultKey;
  useEffect(() => {
    getPotentialReason()
      .then((res: { code: number, data: any[] }) => {
        if (res.code === 0) {
          setData(res.data);
        }
      });
  }, []);
  const reasonList = handleReasonList(data, potentialStatus);
  const selectData = _.map(reasonList, (label, value) => {
    return {
      value,
      label,
      'data-report': `${reportKey}-${value}`,
    };
  });
  return <Select
    data-report={reportKey}
    search={false}
    data={selectData}
    value={value}
    onChange={onChange}
    onClear={onClear}
    clear
  />;
};

export default PotentialReasonSelect;
